import type { ExtraProfileField } from "@jti/fe-common";
import type { IOrderAttributeInput } from "@jti/magento";

export const overrideOrderAttributesWithProfileExtra = (
  orderAttributes: IOrderAttributeInput[],
  userProfileExtraAttributes: ExtraProfileField | undefined
) => {
  if (!userProfileExtraAttributes) {
    return orderAttributes;
  }

  return orderAttributes.map((attribute) => {
    const attributeValueFromProfileExtra = userProfileExtraAttributes[attribute.attribute_code];

    if (Object.hasOwn(userProfileExtraAttributes, attribute.attribute_code) && !!attributeValueFromProfileExtra) {
      return { ...attribute, value: attributeValueFromProfileExtra };
    }

    return attribute;
  });
};
